export default __webpack_public_path__ + "static/zaru_collages_v6-15-bc9ca0d493f1e5980d26d46caefcb493.png";